import { Pipe, PipeTransform } from "@angular/core";
import { NewsDto } from "@api";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";
import { RootState } from "src/app/store";
import * as FromUser from "src/app/store/user/selectors";

@Pipe({ name: "isNewsLikedByMe" })
export class IsNewsLikedByMePipe implements PipeTransform {
  constructor(private store: Store<RootState>) {}

  public transform(news: NewsDto): Observable<boolean> {
    return this.store.select(FromUser.selectUser).pipe(
      filter(user => !!user),
      map(user => news.likes.some(like => like.userId === user.id)),
    );
  }
}
